export enum SnackType {
  Success = 'primary',
  Error = 'error'
}

export interface Snack {
  msg: string
  type: SnackType
}
